import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  messages: [],
  status: '',
  message: ''
}

export const supportSlice = createSlice({
  name: 'support',
  initialState,
  reducers: {
    setSupportIssues: (state, action) => {
      state.messages = action.payload;
    },
  }
});

export const { setSupportIssues } = supportSlice.actions;
export default supportSlice.reducer;